export enum Direction {
    Across = "Across",
    Down = "Down"
}